import { fireFocusByYearType } from 'store/typesActions/types';
import { api } from 'services/api';

export const fireFocusByYear = (code) => async (dispatch) => {
	dispatch({ type: fireFocusByYearType.FIRE_FOCUS_BY_YEAR });
	try {
		const res = await api.get(`/ti/${code}/focus_by_year`);
		const { data } = res || {};
		dispatch({
			type: fireFocusByYearType.FIRE_FOCUS_BY_YEAR_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.statsu === 400) {
			const { message } = response.data;
			dispatch({
				type: fireFocusByYearType.FIRE_FOCUS_BY_YEAR_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: fireFocusByYearType.FIRE_FOCUS_BY_YEAR_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
